import { z } from 'zod';

import { RETURNS_MODES } from 'dictionary';

export const FORM_SCHEMA = z.object({
  mode: z.enum([RETURNS_MODES.BASIC, RETURNS_MODES.ADVANCED])
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  mode: 'BASIC'
};
